import React, { useState } from "react";
import { Input, Radio, TimePicker, message } from "antd";
import CustomInput from "../CustomInput";
import Helper from "../../utils/Helper";
import UploadThumbnailComponent from "../UploadThumbnailComponent";
import DeleteIcon from "../images/DeleteClose";
import AddIcon from "../images/Add";
import { useNavigate } from "react-router-dom";
import useUserStore from "../../stores/store";
import ApiService from "../../utils/ApiService";
import { validateCreateRestaurantData } from "../../services/restaurant-service";
import {CharLimit} from "../../constant/constants";
import CustomInputNumber from "../CustomInputNumber";

export default function RestaurantCreateComponent({}) {
  const navigate = useNavigate();
  const { user } = useUserStore();

  const { TextArea } = Input;

  const [name, setName] = useState("");
  const [branch, setBranch] = useState("Main");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [address, setAddress] = useState("");
  // not set to null
  const [openTime, setOpenTime] = useState("");
  // not set to null
  const [closeTime, setCloseTime] = useState("");
  const [status, setStatus] = useState("");
  const [logoImage, setLogoImage] = useState("");
  const [offerImage, setOfferImage] = useState("");
  const [bannerImages, setBannerImages] = useState([]);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isVatIncluded, setIsVatIncluded] = useState('YES');
  const [vat, setVat] = useState('');
  const [isServiceChargeIncluded, setIsServiceChargeIncluded] = useState('YES');
  const [serviceCharge, setServiceCharge] = useState('');
  const [isSupplementaryDutyIncluded, setIsSupplementaryDutyIncluded] = useState('YES');
  function onHandleOpenTime(timeObj) {
    const tempOpenTime = Helper.get12HrTimeOnly(timeObj);
    setOpenTime(tempOpenTime);
  }

  function onHandleCloseTime(timeObj) {
    const tempCloseTime = Helper.get12HrTimeOnly(timeObj);
    setCloseTime(tempCloseTime);
  }

  function onHandleAddBannerUpload() {
    const tempObj = {
      id: `${Date.now()}`,
      image: "",
    };

    setBannerImages((prevImages) => [...prevImages, tempObj]);
  }

  function handleBannerDelete(bannerId) {
    setBannerImages((prevImages) =>
      prevImages.filter((item) => item.id !== bannerId)
    );
  }

  async function handleSubmit() {
    const errors = validateCreateRestaurantData({
      restaurantName: name,
      branchName: branch,
      address,
      latitude,
      longitude,
      isVatIncluded,
      isServiceChargeIncluded,
      isSupplementaryDutyIncluded
    });

    if (errors.length > 0) {
      message.error(`${errors[0]}`);

      return;
    }

    const formData = new FormData();
    formData.append("restaurantName", name);
    formData.append("branchName", branch);
    formData.append("address", address);
    formData.append("latitude", latitude);
    formData.append("longitude", longitude);
    formData.append("isVatIncluded", isVatIncluded);
    formData.append("vat", vat);
    formData.append("isServiceChargeIncluded", isServiceChargeIncluded);
    formData.append("serviceCharge", serviceCharge);
    formData.append("isSupplementaryDutyIncluded", isSupplementaryDutyIncluded);
    formData.append("openTime", Helper.convertTo24HourFormat(openTime));
    formData.append("closeTime", Helper.convertTo24HourFormat(closeTime));
    formData.append("status", status);
    formData.append("logo", logoImage);
    formData.append("offerImage", offerImage);

    bannerImages.map((banner) => {
      formData.append("bannerImages", banner.image);
    });

    const token = user.token.token;
    const res = await ApiService.RESTAURANT_CREATE(formData, token);

    if (res.code === 200) {
      message.success(`${name} is created successfully!`);
      navigate("/restaurants");
    } else {
      console.error(`Failed to create restaurant. Error: ${res.message}`);
      message.error(`Failed to create restaurant. Please, try again.`);
    }
  }

  return (
    <div className="flex flex-col font-uregular bg-[#FAFAFA] px-[10px]">
      <div className="flex pt-7">
        {/* left side fields */}
        <div className="w-[50%] h-full ">
          <div className="pb-[20px]">
            <CustomInput
              value={name}
              setValue={setName}
              showPadding={false}
              required={false}
              onPressEnter={() => {}}
              maxLength={100}
              placeholder="Restaurant Name"
              inputClasses="indent-5 outline-none h-[48px]"
            />
          </div>

          <div className="pb-[20px]">
            <h1 className="font-[700] leading-[20px] font-[14px] tracking-[0.58px] pb-[10px]">
              Branch <span className="font-ubold text-red-700 ml-[2px]">*</span>
            </h1>
            <CustomInput
              value={branch}
              setValue={setBranch}
              showPadding={false}
              required={false}
              onPressEnter={() => {}}
              placeholder="Restaurant Branch"
              inputClasses="indent-5 outline-none h-[48px]"
            />
          </div>
          <div className="pb-[20px]">
            <h1 className="font-[700] leading-[20px] font-[14px] tracking-[0.58px] pb-[10px]">
              Location{" "}
              <span className="font-ubold text-red-700 ml-[2px]">*</span>
            </h1>
            <div className="flex w-full gap-x-[20px]">
              <div className="w-[48%]">
                <CustomInput
                  value={latitude}
                  setValue={setLatitude}
                  showPadding={false}
                  required={false}
                  onPressEnter={() => {}}
                  placeholder="Lat."
                  inputClasses="indent-5 outline-none h-[48px]"
                />
              </div>
              <div className="w-[48%]">
                <CustomInput
                  value={longitude}
                  setValue={setLongitude}
                  showPadding={false}
                  required={false}
                  onPressEnter={() => {}}
                  placeholder="Long."
                  inputClasses="indent-5 outline-none h-[48px]"
                />
              </div>
            </div>
          </div>
          <div className="pb-[20px]">
            <h1 className="font-[700] leading-[20px] font-[14px] tracking-[0.58px] pb-[10px]">
              Address{" "}
              <span className="font-ubold text-red-700 ml-[2px]">*</span>
            </h1>
            <TextArea
              value={address}
              onChange={(e) => {
                const value = e.target.value;
                if (value.length > CharLimit.Address) return;
                setAddress(value);
              }}
              placeholder="Address"
              autoSize={{ minRows: 4, maxRows: 10 }}
            />
            <div className="mt-1 text-[12px] text-gray-600 italic">Char limit {CharLimit.Address} ({address.length})</div>
          </div>
          
            <div className="py-[20px]">
              <div className="pb-2 font-p_medium font-[12px]">VAT Included ?</div>
              <div>
                <Radio.Group
                  onChange={(e) => setIsVatIncluded(e.target.value)}
                  name="radiogroup"
                  value={isVatIncluded}
                  options={[
                    { value: 'YES', label: 'Yes' },
                    { value: 'NO', label: 'No' },
                  ]}
                />
              </div>
            </div>
            <div className="pb-[20px]">
              <div className="pb-2 font-p_medium font-[12px]">
                Vat (%)
                {/* <span className="text-red-500"> *</span> */}
              </div>
              <div>
                <CustomInputNumber 
                  value={vat}
                  setValue={setVat}
                  placeholder={'0'}
                  isDecimalAllowed={true}
                  max={99}
                  min={0}
                />
              </div>
            </div>
          
            <div className="py-[20px]">
              <div className="pb-2 font-p_medium font-[12px]">Supplementary Duty Included ?</div>
              <div>
                <Radio.Group
                  onChange={(e) => setIsSupplementaryDutyIncluded(e.target.value)}
                  name="radiogroup"
                  value={isSupplementaryDutyIncluded}
                  options={[
                    { value: 'YES', label: 'Yes' },
                    { value: 'NO', label: 'No' },
                  ]}
                />
              </div>
            </div>
            <div className="py-[20px]">
              <div className="pb-2 font-p_medium font-[12px]">Service Charge Included ?</div>
              <div>
                <Radio.Group
                  onChange={(e) => setIsServiceChargeIncluded(e.target.value)}
                  name="radiogroup"
                  value={isServiceChargeIncluded}
                  options={[
                    { value: 'YES', label: 'Yes' },
                    { value: 'NO', label: 'No' },
                  ]}
                />
              </div>
            </div>
            <div className="pb-[20px]">
              <div className="pb-2 font-p_medium font-[12px]">
                Service Charge (%)
                {/* <span className="text-red-500"> *</span> */}
              </div>
              <div>
                <CustomInputNumber 
                  value={serviceCharge}
                  setValue={setServiceCharge}
                  placeholder={'0'}
                  isDecimalAllowed={true}
                  max={99}
                  min={0}
                />
              </div>
            </div>

          {/* open and close time */}
          <div className="pb-[20px] flex justify-start space-x-[20px]">
            <TimePicker
              format="hh:mm A"
              defautValue={openTime}
              placeholder="Open Time"
              use12Hours={true}
              onChange={(value) => onHandleOpenTime(value)}
              className="indent-5 h-[48px]"
              allowClear
            />
            <TimePicker
              format="hh:mm A"
              defautValue={closeTime}
              placeholder="Close Time"
              use12Hours={true}
              onChange={(value) => onHandleCloseTime(value)}
              className="indent-5 h-[48px]"
              allowClear
            />
          </div>
        </div>

        {/* right side fields */}
        <div className="w-[50%] h-full pl-[70px]">
          <div className="mb-[20px]">
            <UploadThumbnailComponent
              key_id="upload-logo"
              placeholderText={"Upload Logo"}
              setImage={setLogoImage}
              isSubmitted={isSubmitted}
              prevImage={logoImage}
              aspect={1 / 1}
            />
          </div>

          <div className="mb-[20px]">
            <UploadThumbnailComponent
              key_id="upload-offer-image"
              placeholderText={"Upload Offer Image"}
              setImage={setOfferImage}
              isSubmitted={isSubmitted}
              prevImage={offerImage}
              aspect={3 / 2}
            />
          </div>

          <div className="">
            {/* header with button */}
            <div className="my-[20px] flex items-center justify-between">
              <h1 className="text-[24px] text-black">
                <span className="font-bold">Upload Banner</span>
              </h1>
              <AddIcon
                attributes={{
                  color: "#000000",
                  size: "30.75",
                  classes: "cursor-pointer",
                }}
                clickHandler={onHandleAddBannerUpload}
              />
            </div>

            <div>
              {bannerImages.map((banner, idx) => {
                if (Boolean(banner.id)) {
                  return (
                    <div
                      id={banner.id}
                      key={banner.id}
                      className="mb-[20px] flex items-start"
                    >
                      <div className="w-[90%]">
                        <UploadThumbnailComponent
                          key_id={`banner-upload-${idx}`}
                          placeholderText={`Banner Upload`}
                          setImage={setBannerImages}
                          bannerId={banner.id}
                          isSubmitted={isSubmitted}
                          banners={bannerImages}
                          prevImage={banner.image}
                          aspect={1 / 1}
                          context="BANNER_IMAGE"
                        />
                      </div>
                      <div className="w-[10%] py-3">
                        <DeleteIcon
                          attributes={{
                            color: "#EE3169",
                            size: "24",
                            classes: "cursor-pointer ml-[7px]",
                          }}
                          clickHandler={() => handleBannerDelete(banner.id)}
                        />
                      </div>
                    </div>
                  );
                }
              })}
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="pb-[67px] flex justify-center space-x-[15px]">
          <button
            className="h-[42px] w-[100px] bg-[#FCBD10] text-black text-[14px] font-bold leading-[16px] rounded-lg"
            onClick={() => navigate("/restaurants")}
          >
            Cancel
          </button>
          <button
            className="h-[42px] w-[100px] bg-[#000000] text-white text-[14px] font-bold leading-[16px] rounded-lg"
            onClick={handleSubmit}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}
